import React, { useEffect } from "react";
import AOS from "aos";
import "./Portfolio.css";
import { Link } from "react-router-dom";
import SEO from "../SEO";
export default function Portfolio() {
  useEffect(() => {
    AOS.init({ duration: 800, offset: 100 });
  }, []);

  const projects = [
    // 🌐 WEBSITES (FIRST IMPRESSION)
    {
      id: 1,
      name: "Clothing E-Commerce Store",
      category: "website",
      icon: "🛍️",
      description:
        "Modern fashion e-commerce website with product catalog, cart, and secure checkout.",
      video: "",
      image: "/img/Anabiyahscollection.png",
      title: "Clothing Store Website",
      delay: 0,
      url: "https://anabiyhscollections.com/",
    },
    {
      id: 2,
      name: "Solar Energy Company Website",
      category: "website",
      icon: "☀️",
      description:
        "Professional solar business website with services, portfolio, and lead generation system.",
      video: "",
      image: "/img/SolidERA-Energy.png",
      title: "Solar Company Website",
      delay: 100,
      url: "http://solidera-energy.com/",
    },
    {
      id: 3,
      name: "Pharmacy Distributor Website",
      category: "website",
      icon: "💊",
      description:
        "Corporate website for pharmaceutical distributor with product listings and company profile.",
      video: "",
      image: "/img/ags.png",
      title: "Pharmacy Website",
      delay: 200,
      url: "https://web.agssukkur.com/",
    },

    // 💻 SOFTWARE (AUTHORITY BUILD)
    {
      id: 4,
      name: "Point of Sale (POS) System",
      category: "software",
      icon: "🛒",
      description:
        "Complete POS system for billing, inventory tracking, and real-time sales management.",
      video: "https://www.youtube.com/embed/MWEID7Io39s",
      title: "POS Demo 1",
      delay: 0,
      url: "/Portfolio/EnterpriseERP/index",
    },
    {
      id: 5,
      name: "Advanced POS Platform",
      category: "software",
      icon: "💳",
      description:
        "Touch-enabled POS with advanced inventory control and multi-user management.",
      video: "https://www.youtube.com/embed/gTiGXKNYYEE",
      title: "POS Demo 2",
      delay: 100,
      url: "/Portfolio/EnterpriseERP/index",
    },
    {
      id: 6,
      name: "Enterprise ERP System",
      category: "software",
      icon: "📦",
      description:
        "All-in-one ERP solution for inventory, accounting, and business operations.",
      video: "https://www.youtube.com/embed/6unp9xeoQMQ",
      title: "ERP Demo",
      delay: 200,
      url: "/Portfolio/EnterpriseERP/index",
    },
    {
      id: 7,
      name: "Pharmacy Inventory System",
      category: "software",
      icon: "💊",
      description:
        "Inventory management system for pharmacies with stock tracking and reporting.",
      video: "https://www.youtube.com/embed/wmhvfZ13V-A",
      title: "Inventory Demo",
      delay: 50,
      url: "/Portfolio/EnterpriseERP/index",
    },
    {
      id: 8,
      name: "School Management System",
      category: "software",
      icon: "🎓",
      description:
        "Complete school system with attendance, exams, fees, and student records.",
      video: "https://www.youtube.com/embed/d1XLbfHnE2o",
      title: "School Demo",
      delay: 150,
      url: "/Portfolio/EnterpriseERP/index",
    },
    {
      id: 9,
      name: "E-Commerce Inventory System",
      category: "software",
      icon: "🛍️",
      description:
        "Manage orders, inventory, and customers for online stores in one dashboard.",
      video: "https://www.youtube.com/embed/XoD6Vnp8U8c",
      title: "Ecommerce Demo",
      delay: 250,
      url: "/Portfolio/EnterpriseERP/index",
    },
  ];
  return (
    <>
      <SEO
        title="Portfolio – MZR Software Projects"
        description="Check out MZR Software’s portfolio of custom software, ERP, cloud, and AI development projects."
        image="https://mzrsoftware.com/assets/images/og-portfolio.jpg"
        url="https://mzrsoftware.com/Portfolio/index"
      />

      <section id="portfolio" className="portfolio-section">
        <div className="container">
          {/* Section Header */}
          <div className="section-header text-center mb-5" data-aos="fade-up">
            <h2 className="section-title">
              Our <span className="highlight">Portfolio</span>
            </h2>
            <p className="section-subtitle">
              500+ successful projects delivered across various industries
            </p>
          </div>

          {/* Portfolio Grid */}
          <div className="portfolio-grid">
            {projects.map((project) => {
              const isExternal = project.url.startsWith("http");

              const Card = (
                <div
                  className="portfolio-card"
                  data-aos="fade-up"
                  data-aos-delay={project.delay}
                >
                  <div className="card-image-wrapper">
                    {/* MEDIA */}
                    {project.video ? (
                      <iframe
                        src={project.video}
                        title={project.title}
                        className="project-video"
                        allowFullScreen
                      ></iframe>
                    ) : (
                      <img
                        src={project.image}
                        alt={project.title}
                        className="project-image"
                      />
                    )}

                    {/* HOVER */}
                    <div className="card-overlay">
                      <span className="project-icon">{project.icon}</span>
                      <span className="visit-icon">🔗 View</span>
                    </div>
                  </div>

                  {/* CONTENT */}
                  <div className="card-content">
                    <h3 className="card-title">{project.name}</h3>

                    <span className="category-badge">
                      {project.category.toUpperCase()}
                    </span>

                    <p className="card-description">{project.description}</p>

                    <span className="card-cta">View Details →</span>
                  </div>
                </div>
              );

              return isExternal ? (
                <a
                  key={project.id}
                  href={project.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="portfolio-link"
                >
                  {Card}
                </a>
              ) : (
                <Link
                  key={project.id}
                  to={project.url}
                  className="portfolio-link"
                >
                  {Card}
                </Link>
              );
            })}
          </div>
          {/* Call to Action */}
          <div className="portfolio-cta text-center mt-5" data-aos="fade-up">
            <p className="cta-text">
              Want to see more projects or discuss your requirements?
            </p>
            <Link to="/contact" className="btn-primary">
              Get Started Today →
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
